import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import auth from './modules/auth';
import account from './modules/account';
import address from './modules/addressForm';
import viewBag from './modules/viewBag';
import fiasUpdates from './modules/fiasUpdates';
import { routerReducer } from 'react-router-redux';

export default combineReducers({
  form: formReducer,
  routing: routerReducer,
  auth,
  account,
  viewBag,
  address,
  fiasUpdates
});



// WEBPACK FOOTER //
// ./Scripts/redux/reducer.js